import axios from 'src/utils/axios'
import { API_BASE_URL } from 'src/constants'

export const fetchHPOTerms = async (params = {}) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/hpo/`, {
      params: {
        limit: 100,
        ...params,
      },
    })
    return response.data.results || []
  } catch (error) {
    console.error('Error fetching HPO terms:', error)
    throw error
  }
}
